import { useState } from 'react';
import StoreOpenTables, {
  StoreOpenInteriorDetailDialog,
} from '@/components/Approval/@components/StoreOpen';
import useMyBrandOptions from '@/hooks/approval/useMyBrandOptions';
import useStoreOpenInteriorDetail from '@/hooks/approval/useStoreOpenInteriorDetail';
import {
  formatStoreOpenNumber,
  isStoreOpenDirectShop,
  parseStoreOpenAttributes,
  STORE_OPEN_NUMBER_KEYS,
  storeOpenDetailTotal,
} from '@/utils/approval/storeOpen';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 8 (구)매장 OPEN 품의 백화점·직영점 — 저장값으로 표를 다시 그림(레거시 조회와 동일). 대리점은 본문만 */
const StoreOpenSlot = ({ data }: ContentExtraProps) => {
  const saved = parseStoreOpenAttributes(data.attributes);
  const { options: brandOptions } = useMyBrandOptions();
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const savedDetail = useStoreOpenInteriorDetail(data.documentId, isDetailOpen);

  if (!saved) return null;

  const { values } = saved;

  return (
    <ContentSlotRoot>
      <StoreOpenTables
        isDirectShop={isStoreOpenDirectShop(saved)}
        isNoInterior={saved.isNoInterior}
        hasValue={(keys) =>
          keys.some((key) => values[key] !== null && values[key] !== '')
        }
        onShowDetail={() => setIsDetailOpen(true)}
        renderCell={(key) => {
          switch (key) {
            case 'brand':
              return (
                saved.brandName ??
                brandOptions.find((o) => o.value === saved.brandCode)?.label ??
                saved.brandCode
              );
            case 'shopName':
            case 'openDate':
            case 'shopArea':
            case 'shopForm':
            case 'constructionType':
            case 'interiorCompany':
              return saved[key];
            case 'interiorCost':
              return saved.isNoInterior
                ? ''
                : formatStoreOpenNumber(saved.interiorCost);
            default:
              return STORE_OPEN_NUMBER_KEYS.includes(key)
                ? formatStoreOpenNumber(values[key])
                : values[key] ?? '';
          }
        }}
      />
      {!saved.isNoInterior && (
        <StoreOpenInteriorDetailDialog
          open={isDetailOpen}
          onClose={() => setIsDetailOpen(false)}
          detail={savedDetail.detail}
          legacyHtml={savedDetail.legacyHtml}
          total={storeOpenDetailTotal(saved, saved.interiorCost)}
          isLoading={savedDetail.isLoading}
          isError={savedDetail.isError}
        />
      )}
    </ContentSlotRoot>
  );
};

export default StoreOpenSlot;
